// Forbidden characters - Sonora menu/results dismissed if the first character in the query string matches any of these
const SONORA_FORBIDDEN_CHARS = ['"', ':', '<', '>', '/', '\\', '|'];

export default function containsSonoraForbiddenCharacter(queryString: string) {
    return queryString.length > 0 && SONORA_FORBIDDEN_CHARS.indexOf(queryString[0]) >= 0;
}
